<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="主键ID" prop="id">
                <Input type="text" v-model="searchForm.id" placeholder="请输入主键ID" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="订单号" prop="orderSeqNo">
                <Input type="text" v-model="searchForm.orderSeqNo" placeholder="请输入订单号" clearable style="width: 200px"/>
              </Form-item>
              <span v-if="drop">
                <Form-item label="存证id" prop="evidenceArchiveId">
                  <Input type="text" v-model="searchForm.evidenceArchiveId" placeholder="请输入存证id" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="账户类型：person- 个人  enterprise-企业" prop="accType">
                  <Input type="text" v-model="searchForm.accType" placeholder="请输入账户类型：person- 个人  enterprise-企业" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="账户ID" prop="registerId">
                  <Input type="text" v-model="searchForm.registerId" placeholder="请输入账户ID" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="业务类型 01 存证  02 登记    03 取证   04 监测     05 法律服务   06平台活动   07 充值   08 会员开通  09版权交易  10会员续费  9999其他业务  此表中固定为03" prop="bizType">
                  <Input type="text" v-model="searchForm.bizType" placeholder="请输入业务类型 01 存证  02 登记    03 取证   04 监测     05 法律服务   06平台活动   07 充值   08 会员开通  09版权交易  10会员续费  9999其他业务  此表中固定为03" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="0101 DCI存证  0102 司法存证                0201 DCI登记  0202 贵州登记              0301 网页取证  0302 录屏取证 0303 APP取证 0304 APP拍照取证 0305 APP录像取证 0306 APP录屏取证  0307 现场取证 （此字段只能是此范围的值）              0401 图片监测  0402文字监测  0403 音视频监测              0501 问律师服务（30分钟） 0502 问律师服务（60分钟） 0503 合同审核 0504 侵权下架  0505 侵权判定 0506 出具律师函                0601 红包获得  0602 免费版权服务              0701 钱包充值               会员开通              0901 版权交易              " prop="subBizType">
                  <Input type="text" v-model="searchForm.subBizType" placeholder="请输入0101 DCI存证  0102 司法存证                0201 DCI登记  0202 贵州登记              0301 网页取证  0302 录屏取证 0303 APP取证 0304 APP拍照取证 0305 APP录像取证 0306 APP录屏取证  0307 现场取证 （此字段只能是此范围的值）              0401 图片监测  0402文字监测  0403 音视频监测              0501 问律师服务（30分钟） 0502 问律师服务（60分钟） 0503 合同审核 0504 侵权下架  0505 侵权判定 0506 出具律师函                0601 红包获得  0602 免费版权服务              0701 钱包充值               会员开通              0901 版权交易              " clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="证据名称" prop="evidName">
                  <Input type="text" v-model="searchForm.evidName" placeholder="请输入证据名称" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="取证网址" prop="evidUrl">
                  <Input type="text" v-model="searchForm.evidUrl" placeholder="请输入取证网址" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="取证备注说明" prop="evidContent">
                  <Input type="text" v-model="searchForm.evidContent" placeholder="请输入取证备注说明" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="来源" prop="source">
                  <Input type="text" v-model="searchForm.source" placeholder="请输入来源" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="支付状态" prop="payStatus">
                  <Input type="text" v-model="searchForm.payStatus" placeholder="请输入支付状态" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="创建者" prop="createBy">
                  <Input type="text" v-model="searchForm.createBy" placeholder="请输入创建者" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="创建时间" prop="createDate">
                  <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                </Form-item>
                <Form-item label="更新者" prop="updateBy">
                  <Input type="text" v-model="searchForm.updateBy" placeholder="请输入更新者" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="更新时间" prop="updateDate">
                  <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                </Form-item>
                <Form-item label="备注信息" prop="remarks">
                  <Input type="text" v-model="searchForm.remarks" placeholder="请输入备注信息" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="删除标记" prop="delFlag">
                  <Input type="text" v-model="searchForm.delFlag" placeholder="请输入删除标记" clearable style="width: 200px"/>
                </Form-item>
              </span>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
            <Button @click="add" type="primary" icon="md-add">添加</Button>
            <Button @click="delAll" icon="md-trash">批量删除</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >        <FormItem label="主键ID" prop="id" >
          <Input v-model="form.id" style="width:100%"/>
        </FormItem>
        <FormItem label="订单号" prop="orderSeqNo" >
          <Input v-model="form.orderSeqNo" style="width:100%"/>
        </FormItem>
        <FormItem label="存证id" prop="evidenceArchiveId" >
          <Input v-model="form.evidenceArchiveId" style="width:100%"/>
        </FormItem>
        <FormItem label="账户类型：person- 个人  enterprise-企业" prop="accType" >
          <Input v-model="form.accType" style="width:100%"/>
        </FormItem>
        <FormItem label="账户ID" prop="registerId" >
          <Input v-model="form.registerId" style="width:100%"/>
        </FormItem>
        <FormItem label="业务类型 01 存证  02 登记    03 取证   04 监测     05 法律服务   06平台活动   07 充值   08 会员开通  09版权交易  10会员续费  9999其他业务  此表中固定为03" prop="bizType" >
          <Input v-model="form.bizType" style="width:100%"/>
        </FormItem>
        <FormItem label="0101 DCI存证  0102 司法存证                0201 DCI登记  0202 贵州登记              0301 网页取证  0302 录屏取证 0303 APP取证 0304 APP拍照取证 0305 APP录像取证 0306 APP录屏取证  0307 现场取证 （此字段只能是此范围的值）              0401 图片监测  0402文字监测  0403 音视频监测              0501 问律师服务（30分钟） 0502 问律师服务（60分钟） 0503 合同审核 0504 侵权下架  0505 侵权判定 0506 出具律师函                0601 红包获得  0602 免费版权服务              0701 钱包充值               会员开通              0901 版权交易              " prop="subBizType" >
          <Input v-model="form.subBizType" style="width:100%"/>
        </FormItem>
        <FormItem label="证据名称" prop="evidName" >
          <Input v-model="form.evidName" style="width:100%"/>
        </FormItem>
        <FormItem label="取证网址" prop="evidUrl" >
          <Input v-model="form.evidUrl" style="width:100%"/>
        </FormItem>
        <FormItem label="取证备注说明" prop="evidContent" >
          <Input v-model="form.evidContent" style="width:100%"/>
        </FormItem>
        <FormItem label="来源" prop="source" >
          <Input v-model="form.source" style="width:100%"/>
        </FormItem>
        <FormItem label="支付状态" prop="payStatus" >
          <Input v-model="form.payStatus" style="width:100%"/>
        </FormItem>
        <FormItem label="创建者" prop="createBy" >
          <Input v-model="form.createBy" style="width:100%"/>
        </FormItem>
        <FormItem label="创建时间" prop="createDate" >
            <DatePicker type="date" v-model="form.createDate" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="更新者" prop="updateBy" >
          <Input v-model="form.updateBy" style="width:100%"/>
        </FormItem>
        <FormItem label="更新时间" prop="updateDate" >
            <DatePicker type="date" v-model="form.updateDate" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="备注信息" prop="remarks" >
          <Input v-model="form.remarks" style="width:100%"/>
        </FormItem>
        <FormItem label="删除标记" prop="delFlag" >
          <Input v-model="form.delFlag" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "EvidenceOrder",
  components: {
  },
  data() {
    return {
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "a.create_date", // 默认排序字段
        order: "desc", // 默认排序方式
        startDate: "", // 起始时间
        endDate: "" // 终止时间
      },
      selectDate: null,
      form: { // 添加或编辑表单对象初始化数据
        id: "",
        orderSeqNo: "",
        evidenceArchiveId: "",
        accType: "",
        registerId: "",
        bizType: "",
        subBizType: "",
        evidName: "",
        evidUrl: "",
        evidContent: "",
        source: "",
        payStatus: "",
        createBy: "",
        createDate: "",
        updateBy: "",
        updateDate: "",
        remarks: "",
        delFlag: "",
      },
      // 表单验证规则
      formValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "主键ID",
          key: "id",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "订单号",
          key: "orderSeqNo",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "存证id",
          key: "evidenceArchiveId",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "账户类型：person- 个人  enterprise-企业",
          key: "accType",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "账户ID",
          key: "registerId",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "业务类型 01 存证  02 登记    03 取证   04 监测     05 法律服务   06平台活动   07 充值   08 会员开通  09版权交易  10会员续费  9999其他业务  此表中固定为03",
          key: "bizType",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "0101 DCI存证  0102 司法存证                0201 DCI登记  0202 贵州登记              0301 网页取证  0302 录屏取证 0303 APP取证 0304 APP拍照取证 0305 APP录像取证 0306 APP录屏取证  0307 现场取证 （此字段只能是此范围的值）              0401 图片监测  0402文字监测  0403 音视频监测              0501 问律师服务（30分钟） 0502 问律师服务（60分钟） 0503 合同审核 0504 侵权下架  0505 侵权判定 0506 出具律师函                0601 红包获得  0602 免费版权服务              0701 钱包充值               会员开通              0901 版权交易              ",
          key: "subBizType",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证据名称",
          key: "evidName",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "取证网址",
          key: "evidUrl",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "取证备注说明",
          key: "evidContent",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "来源",
          key: "source",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "支付状态",
          key: "payStatus",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "创建者",
          key: "createBy",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "创建时间",
          key: "createDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "更新者",
          key: "updateBy",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "更新时间",
          key: "updateDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "备注信息",
          key: "remarks",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "删除标记",
          key: "delFlag",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    icon: "md-trash"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      // this.getRequest("请求路径", this.searchForm).then(res => {
      //   this.loading = false;
      //   if (res.success) {
      //     this.data = res.result.records;
      //     this.total = res.result.total;
      //   }
      // });
      // 以下为模拟数据
      //this.data = [
      //];
      this.total = this.data.length;
      this.loading = false;
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          } else {
            // 编辑
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          }
        }
      });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      this.modalVisible = true;
    },
    edit(v) {
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.modalVisible = true;
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.name + " ?",
        loading: true,
        onOk: () => {
          // 删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + v.id).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.getDataList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + ids).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.clearSelectAll();
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.clearSelectAll();
          this.getDataList();
        }
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>